import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()


/**
 * Fullscreen Resizing
 */

// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

// Event Listener for resizing of window.
window.addEventListener('resize', () =>
{
    // Log in console
    console.log("Detected window resize.")

    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 5))
})

// Event Listener for double click full screen
window.addEventListener('dblclick', () =>
{
    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement

    if(!fullscreenElement)
    {
        if(canvas.requestFullscreen)
        {
            canvas.requestFullscreen()
        }
        else if(canvas.webkitRequestFullscreen)
        {
            canvas.webkitRequestFullscreen()
        }
    }
    else
    {
        if(document.exitFullscreen)
        {
            document.exitFullscreen()
        }
        else if(document.webkitExitFullscreen)
        {
            document.webkitExitFullscreen()
        }
    }
})


/**
 * Object
 */
const geometry = new THREE.BoxGeometry(1, 1, 1)
const material = new THREE.MeshBasicMaterial({ color: 0xff0000 })
const mesh = new THREE.Mesh(geometry, material)
scene.add(mesh)

const torusgeometry = new THREE.TorusGeometry(0.5 , 0.4)
const torusmaterial = new THREE.MeshNormalMaterial()
const torusmesh = new THREE.Mesh(torusgeometry, torusmaterial)
scene.add(torusmesh)
torusmesh.position.y = 2
/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.z = 3
scene.add(camera)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.render(scene, camera)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 5))
// Controls
const controls = new OrbitControls(camera, canvas)


/**
 * Debug
 */
const gui = new GUI({
    width: 300,
    title: 'More Options'
})
gui.addFolder("Cube properties")
gui.add(mesh.position, 'y', - 4, 4, 0.01)
gui.add(mesh.position, 'x', - 4, 4, 0.01)
gui.add(mesh.position, 'z', - 4, 4, 0.01)
gui.add(material, 'wireframe')
gui.addColor(material, 'color')
gui.hide()
window.addEventListener('keydown', (event) =>
{
    if(event.key == 'h')
        gui.show(gui._hidden)
})
gui.addFolder("Torus properties")
gui.add(torusmesh.position, 'y', - 4, 4, 0.01)
gui.add(torusmesh.position, 'x', - 4, 4, 0.01)
gui.add(torusmesh.position, 'z', - 4, 4, 0.01)
gui.add(torusmaterial, 'wireframe')

/**
 * JS Functions
 */

// FPS Measurement (broken)
var startTime, endTime, seconds, frames, timeDiff;
function start() {
    startTime = performance.now();
};
function end() {
    endTime = performance.now();
    var timeDiff = endTime - startTime; //in ms 
    // strip the ms 
    timeDiff /= 1000;
};
const FuncAdder = {}
FuncAdder.Measure = () => {
    start()
    while ( seconds <= 1 ){
        console.log("FPS: " + frames)
    }
    end()


}

//FuncAdder can help us add functions to tht debug menu.
gui.add(FuncAdder, 'Measure')
FuncAdder.subdivision = 5

gui.addFolder("Cube subdivision")
gui
    .add(FuncAdder, 'subdivision')
    .min(1)
    .max(30)
    .step(1)
    .onFinishChange(() =>
    {
        mesh.geometry = new THREE.BoxGeometry(
            1, 1, 1,
            FuncAdder.subdivision, FuncAdder.subdivision, FuncAdder.subdivision
        )
    })


gui.addFolder("Torus properties")
gui
    .add(FuncAdder, 'subdivision')
    .min(1)
    .max(30)
    .step(1)
    .onFinishChange(() =>
    {
        torusmesh.geometry = new THREE.TorusGeometry(
            0.5, 0.4,
            FuncAdder.subdivision, FuncAdder.subdivision
        )
    })


/**
 * Update WebGL
 */
const tick = () =>
{
    // Update objects
    mesh.rotation.y += 0.01

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)

    // FPS function code
    var seconds = Math.round(timeDiff);
    frames = frames + 1
}

tick()